import { jwtDecode } from "jwt-decode";
import { getJwt } from "./getJwt";
import removeClientSideStorage from "./functions";
import { callExternalTrigger } from "../context/AuthContext";

const jwtDecoder = async (): Promise<string | null> => {
  const token: any = getJwt();

  if (!token) {
    removeClientSideStorage();
    // window.location.href = "/login";
    return null;
  }

  try {
    const decoded: any = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
      callExternalTrigger();
      return null;
    }

    return token;
  } catch (error) {
    console.error("error", error);
    removeClientSideStorage();
    // window.location.href = "/login";
    return null;
  }
};

export default jwtDecoder;
